import React, { useState, useEffect } from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import { EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'
import apiRequest from '../../hooks/ApiRequest'
import Layouts from '../../components/Layouts'
import { toast } from 'react-toastify'
import AddEditAssigneTemplate from './AddEditAssigneTemplate'
import CommonSearch from '../../hooks/Search'

const AssigneTempalte = () => {
  const [nationalID, setNationalID] = useState('')
  const [baseData, setBaseData] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectTemplateID, setSelectTemplateID] = useState(null)
  const loggedInUserID = JSON.parse(localStorage.getItem('loggedInUserID'))
  const user = JSON.parse(localStorage.getItem('user'))

  useEffect(() => {
    fetchTemplates()
  }, [])

  const fetchTemplates = async () => {
    setLoading(true)
    try {
      if (user.role == '308') {
        const response = await apiRequest(
          process.env.REACT_APP_BASE_URL_EMAIL + `/RegisterEmail/GetByInsurerId/${loggedInUserID}`,
          'GET',
        )
        setBaseData(response.data)
      } else {
        const response = await apiRequest(
          process.env.REACT_APP_BASE_URL_EMAIL + `/RegisterEmail/GetAll`,
          'GET',
        )
        setBaseData(response.data)
      }
    } catch (error) {
      console.error('Error fetching email templates', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSearch = value => {
    const filterTable = baseData.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setBaseData(filterTable)
  }
  const ClearSerach = () => {
    setNationalID('')
    setBaseData(baseData)
    fetchTemplates()
  }

  const handleCreateEmailTemplate = () => {
    setSelectTemplateID(null)
    setModalVisible(true)
  }

  const handleEditEmailTemplate = templateId => {
    setSelectTemplateID(templateId)
    setModalVisible(true)
  }

  const handleDeleteEmailTemplate = async templateId => {
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_EMAIL +
        `/RegisterEmail/Delete/${templateId}`,
        'POST',
      )
      if (response.success) {
        toast.success('Template deleted successfully')
        fetchTemplates()
      } else {
        toast.error(response.error || 'Error deleting template')
      }
    } catch (error) {
      toast.error('Something went wrong. Please try again.')
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchTemplates()
  }

  const columns = [
    { title: 'Name', dataIndex: 'templateName', key: 'templateName' },
    ...(user?.role === '308'
      ? [
        {
          title: 'Actions',
          key: 'actions',
          render: (_, record) => (
            <>
              <Tooltip title="Edit">
                <Button
                  type="primary"
                  className="edit_btn"
                  onClick={() => handleEditEmailTemplate(record.id)}
                >
                  <EditOutlined />
                </Button>
              </Tooltip>
              <Popconfirm
                title="Are you sure you want to delete this template?"
                onConfirm={() => handleDeleteEmailTemplate(record.id)}
                okText="Yes"
                cancelText="No"
              >
                <Tooltip title="Delete">
                  <Button
                    type="primary"
                    danger
                    className="delete_btn"
                    style={{ marginLeft: 8 }}
                  >
                    <DeleteOutlined />
                  </Button>
                </Tooltip>
              </Popconfirm>
            </>
          ),
        },
      ]
      : []),
  ]

  return (
    <div
      title="Email Templates"
      className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                Assigne Templates List
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={5}>
            <div className="item-search">
              <CommonSearch
                value={nationalID}
                onChange={e => setNationalID(e.target.value)}
                onSearch={handleSearch}
                onClear={ClearSerach}
              />
            </div>
          </Col>
          <Col xs={10} sm={10} md={6} lg={3} xl={3}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={() => handleSearch(nationalID)}
                style={{ marginLeft: 10 }}>
                Search
              </Button>
            </div>
          </Col>
          {user.role == '308' && (<Col xs={14} sm={14} md={6} lg={5} xl={4}>
            <div className="create-quotation">
              <Button type="primary" onClick={handleCreateEmailTemplate}>
                Assigne Template
              </Button>
            </div>
          </Col>)}
        </Row>
      </div>

      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{ display: 'block', marginTop: 20 }}
        />
      ) : (
        <Table columns={columns} dataSource={baseData} rowKey="id" />
      )}

      <Modal
        title={selectTemplateID ? 'Edit Assigne Template' : 'Assigne Template'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}>
        <AddEditAssigneTemplate
          templateId={selectTemplateID}
          onSuccess={handleModalClose}
        />
      </Modal>
    </div>
  )
}

export default AssigneTempalte
